<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {
        getMembershipList,
        purchaseMembership,
        getAllActiveMemberships,
        checkMembershipAvailable
    } from "src/components/cabinet/#services/memberships"
    import IconifyIcon from '@iconify/svelte'
    import checkIcon from '@iconify/icons-fa-solid/check-circle'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte'
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import {myBalance} from "src/components/cabinet/#services/myBalance"
    import silverIcon from '../../../../materials/images/memberships/silver.svg'
    import goldIcon from '../../../../materials/images/memberships/gold.svg'
    import platinumIcon from '../../../../materials/images/memberships/platinum.svg'
    import {showAlert} from 'src/components/#common/alert/store'
    import {Link} from 'svelte-routing'
    import dragonsIcon from 'src/components/#assets/dragons.jpg'
    import catsIcon from 'src/components/#assets/cats.jpg'
    import foxesIcon from 'src/components/#assets/foxes.jpg'
    import dogeIcon from 'src/components/#assets/doge.jpg'
    import elonIcon from 'src/components/#assets/elon.jpg'
    import cryptoPepeIcon from 'src/components/#assets/pepe.jpg'
    import {currencyTransfer} from 'src/components/cabinet/#services/myTransactions'
    import {userProfile} from 'src/services/auth'

    const membershipIcons = {
        'silver': silverIcon,
        'gold': goldIcon,
        'platinum': platinumIcon
    }

    getMembershipList.reset()
    getMembershipList.send()
    getAllActiveMemberships.reset()
    getAllActiveMemberships.send()
    checkMembershipAvailable.reset()
    checkMembershipAvailable.send({data: { userId: $userProfile.userId }})

    let buySending = false
    let membershipModalOpen = false
    let selectedMembership
    let selectedGameId = 3

    function showMembershipModal(membership, membershipId, priceInLis, membershipIcon) {
        membershipModalOpen = true
        selectedMembership = {
            name: membership,
            id: membershipId,
            priceInLis,
            icon: membershipIcon
        }
    }

    async function buyMembership() {
        try {
            buySending = true

            if ($myBalance.hasValue && ($myBalance.value.data.DRAG + $myBalance.value.data.PWLIS) < selectedMembership.priceInLis &&
               ($myBalance.value.data.DRAG + $myBalance.value.data.PWLIS + $myBalance.value.data.LIS + $myBalance.value.data.PLIS) >= selectedMembership.priceInLis) {
                await currencyTransfer.request({ data: {
                    fromCurrency: 'LIS',
                    toCurrency: 'DRAG',
                    amount: (+selectedMembership.priceInLis - ($myBalance.value.data.DRAG + $myBalance.value.data.PWLIS)).toString(),
                }})
            }

            await purchaseMembership.request({
                data: {
                    membershipId: selectedMembership.id,
                    appId: selectedGameId
                }
            })

            myBalance.send()

            checkMembershipAvailable.reset()

            showAlert.set({
                status: 'success',
                text: 'You have successfully purchased a membership'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            buySending = false
            membershipModalOpen = false

            window.scrollTo(0, 0)

            myBalance.send()
            getMembershipList.reset()
            getMembershipList.send()
            getAllActiveMemberships.reset()
            getAllActiveMemberships.send()
        }
    }
</script>

<svelte:head>
    <title>Memberships</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <Alert />
            <div class="page-title">Memberships</div>
            {#if !$getMembershipList.hasValue && $getMembershipList.loading}
                <div class="membership-list">
                    {#each {length: 3} as {}}
                        <div class="membership-card">
                            <div class="card-header">
                                ..... <span class="left">left ..</span>
                            </div>
                            <div class="card-body">
                                <div class="price"><span class="notranslate">... DRAG</span><span class="month">/month</span></div>
                                <hr>
                                <ul>
                                    <li>
                                        <IconifyIcon icon={checkIcon} class="check-icon"/> Iron
                                    </li>
                                    <li>
                                        <IconifyIcon icon={checkIcon} class="check-icon"/> Gold
                                    </li>
                                    <li>
                                        <IconifyIcon icon={checkIcon} class="check-icon"/> 2 Diamond
                                    </li>
                                </ul>
                                <hr>
                                <button class="btn active-btn" disabled><span>Buy</span></button>
                            </div>
                        </div>
                    {/each}
                </div>
            {:else if !$getMembershipList.hasValue && $getMembershipList.error }
                Something went wrong. Try refreshing the page.<br><br>
            {:else if $getMembershipList.value}
                <div class="membership-list">
                    {#each $getMembershipList.value as {membership, maxCount, priceInLis, price, membershipId, priorityIndex}}
                        <div class="membership-card">
                            {#if membershipId === 4}
                                <div class="top notranslate">top</div>
                            {/if}
                            <div class="card-header">
                                {membership} <span class="left">left {maxCount}</span>
                            </div>
                            <div class="card-body">
                                <div class="price"><span class="notranslate">{priceInLis} DRAG</span><span class="month">/month</span></div>
                                <hr>
                                <ul>
                                    <li class="active">
                                        <IconifyIcon icon={checkIcon} class="check-icon"/> Iron
                                    </li>
                                    <li class:active={membershipId === 4 || membershipId === 5}>
                                        <IconifyIcon icon={checkIcon} class="check-icon"/> Gold
                                    </li>
                                    <li class:active={membershipId === 5}>
                                        <IconifyIcon icon={checkIcon} class="check-icon"/> 2 Diamond
                                    </li>
                                </ul>
                                <hr>
                                <button class="btn active-btn"
                                    on:click={() => showMembershipModal(membership, membershipId, priceInLis, membershipIcons[membership])}
                                    disabled={maxCount <= 0 || !$checkMembershipAvailable.hasValue || !$checkMembershipAvailable.value.isAvailable}>
                                    <span>Buy</span>
                                </button>
                            </div>
                        </div>
                    {/each}
                </div>
            {/if}
            <Modal bind:visible={membershipModalOpen}>
                <svelte:fragment slot="content">
                    <div class="modal-custom__title">Confirm payment</div>
                    <div class="modal-custom__text">
                        <div>Choose which game</div>
                        <div class="form-check game-list">
                            <label class="form-check-label game-item">
                                <input type="radio" name="game" class="form-check-input" value={3} bind:group={selectedGameId}>Crypto Cats
                            </label>
                            <label class="form-check-label game-item">
                                <input type="radio" name="game" class="form-check-input" value={5} bind:group={selectedGameId}>Crypto Dragons
                            </label>
                            <label class="form-check-label game-item">
                                <input type="radio" name="game" class="form-check-input" value={7} bind:group={selectedGameId}>Crypto Fox
                            </label>
                            <label class="form-check-label game-item">
                                <input type="radio" name="game" class="form-check-input" value={11} bind:group={selectedGameId}>Crypto DOGE
                            </label>
                            <label class="form-check-label game-item">
                                <input type="radio" name="game" class="form-check-input" value={13} bind:group={selectedGameId}>Elon Game
                            </label>
                            <label class="form-check-label game-item">
                                <input type="radio" name="game" class="form-check-input" value={15} bind:group={selectedGameId}>Crypto Frepe
                            </label>
                        </div>
                        <div class="my-balance">Wallet balance: {!$myBalance.hasValue ? ".." : $myBalance.value.data.DRAG + $myBalance.value.data.PWLIS} LIS</div>
                        {#if $myBalance.hasValue && ($myBalance.value.data.DRAG + $myBalance.value.data.PWLIS) < selectedMembership.priceInLis && ($myBalance.value.data.BLIS + $myBalance.value.data.DRAG + $myBalance.value.data.PWLIS + $myBalance.value.data.LIS + $myBalance.value.data.PLIS) >= selectedMembership.priceInLis}
                            <div class="transfer-message">Not enough DRAG on the Wallet balance. We will <Link to="account">transfer</Link> DRAG from the Game balance to the Wallet balance.</div>
                        {/if}
                        <div class="selected-membership">
                            <div class="row">
                                <div class="col-md-6 left-text"><img src={selectedMembership.icon} class="membership-icon" alt="">{selectedMembership.name}</div>
                                <div class="col-md-6 right-text"><span class="notranslate">{selectedMembership.priceInLis} DRAG</span><span class="modal-month">/month</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { membershipModalOpen = false }}>Close</button>
                        <button class="btn btn-primary" class:loading={buySending} on:click={() => buyMembership()}
                            disabled={buySending}><span>Buy</span></button>
                    </div>
                </svelte:fragment>
            </Modal>
            {#if !$getAllActiveMemberships.hasValue && $getAllActiveMemberships.loading}
                Loading...
            {:else if !$getAllActiveMemberships.hasValue && $getAllActiveMemberships.error }
                Something went wrong. Try refreshing the page.
            {:else if $getAllActiveMemberships.value && $getAllActiveMemberships.value?.length > 0}
                <div class="my-memberships-table">
                    <div class="membership-table-header">
                        <div>Membership</div>
                        <div>Game</div>
                        <div>Status</div>
                        <div>Duration</div>
                    </div>
                    <div class="membership-table-body">
                        {#each $getAllActiveMemberships.value as { appId, membership, endDate, duration, id }}
                            <div class="membership-table-row">
                                <div>
                                    <img src={membershipIcons[membership.name]} class="icon" alt="">
                                    <span class="membership-name">{membership.name}</span>
                                </div>
                                <div>
                                    <span class="label d-md-none">Game</span>
                                    {#if appId === 3}
                                        <span><img src={catsIcon} class="icon" alt="">Crypto Cats</span>
                                    {:else if appId === 5}
                                        <span><img src={dragonsIcon} class="icon" alt="">Crypto Dragons</span>
                                    {:else if appId === 7}
                                        <span><img src={foxesIcon} class="icon" alt="">Crypto Fox</span>
                                    {:else if appId === 11}
                                        <span><img src={dogeIcon} class="icon" alt="">Crypto DOGE</span>
                                    {:else if appId === 13}
                                        <span><img src={elonIcon} class="icon" alt="">Elon Game</span>
                                    {:else if appId === 15}
                                        <span><img src={cryptoPepeIcon} class="icon" alt="">Crypto Frepe</span>
                                    {/if}
                                </div>
                                <div>
                                    <span class="label d-md-none">Status</span>
                                    {#if duration}
                                        <span class="status-queue">Queue</span>
                                    {:else}
                                        <span class="status-active">Active</span>
                                    {/if}
                                </div>
                                <div>
                                    <span class="label d-md-none">Duration</span>
                                    {#if endDate}
                                        Left {Math.floor((new Date(endDate) - new Date()) / (1000 * 3600 * 24))} days
                                    {:else if duration}
                                        Duration {Math.floor(new Date(+duration) / 24)} days
                                    {:else}
                                        Subscription
                                    {/if}
                                </div>
                            </div>
                        {/each}
                    </div>
                </div>
            {/if}
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .membership-list {
        display: flex;
        justify-content: center;
        margin: 100px 0 50px;
    }

    .membership-card {
        width: 358px;
        border: 2px solid #353064;
        background: #26244D;
        border-radius: 20px;
        overflow: hidden;
        margin: 0 25px;
        position: relative;
        filter: drop-shadow(0px 0px 30px rgba(255, 255, 255, 0.0));
        transition: all .4s;
    }

    .membership-card:hover {
        border-color: white;
        box-shadow: 0 0 0 1px white;
        filter: drop-shadow(0px 0px 30px rgba(255, 255, 255, 0.3));
        transform: scale(1.1);
    }

    .card-header {
        background: #7262ff;
        border-bottom: 0;
        padding: 20px 30px;
        font-size: 30px;
        color: white;
        line-height: 30px;
        font-weight: 500;
        display: flex;
        align-items: center;
        text-transform: capitalize;
    }

    .transfer-message {
        font-size: 14px;
        color: #272C33;
        margin: 15px 0 15px;
        background: #CAD5E0;
        padding: 10px;
        border-radius: 6px;
        font-weight: 500;
    }

    .transfer-message :global(a),
    .transfer-message :global(a:hover) {
        color: #272C33;
    }

    .left {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        padding: 7px 10px;
        background: #27AE60;
        border-radius: 5px;
        color: white;
        margin-left: 15px;
        text-transform: lowercase;
    }

    .card-body {
        padding: 30px;
    }

    .price {
        background: #494591;
        border-radius: 12px;
        font-weight: 800;
        font-size: 36px;
        padding: 15px;
        line-height: 1;
        text-align: center;
    }

    .price .month {
        font-size: 14px;
        color: #a1b3c5;
        font-weight: 400;
        padding-left: 5px;
    }

    hr {
        background: #494591;
        opacity: 1;
        margin: 30px 0;
    }

    ul {
        list-style: none;
        padding: 0;
    }

    ul li {
        opacity: 0.3;
        display: flex;
        align-content: center;
    }

    ul li.active {
        opacity: 1;
    }

    ul li:not(:last-child) {
        margin-bottom: 25px;
    }

    .card-body :global(.check-icon) {
        color: #CAD5E0;
        margin-right: 18px;
    }

    .card-body .btn {
        width: 100%;
    }

    .top {
        background: #FF2301;
        transform: rotate(38.75deg);
        font-size: 16px;
        line-height: 16px;
        color: white;
        font-weight: 800;
        position: absolute;
        right: -30px;
        top: 5px;
        text-transform: uppercase;
        padding: 7px 40px;
    }

    .my-balance {
        font-size: 14px;
        color: #CAD5E0;
        margin: 50px 0 10px;
    }

    .selected-membership {
        background: rgba(89, 89, 142, 0.3);
        border-radius: 6px;
        padding: 25px 30px;
    }

    .selected-membership .left-text {
        font-size: 20px;
        line-height: 20px;
        font-weight: 500;
        text-transform: capitalize;
    }

    .selected-membership .right-text {
        text-align: right;
        font-size: 24px;
        font-weight: 800;
        line-height: 24px;
    }

    .selected-membership .right-text .modal-month {
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
        padding-left: 5px;
        color: #CAD5E0;
    }

    .game-item {
        background: rgba(89, 89, 142, 0.3);
        border-radius: 6px;
        padding: 8px;
        font-size: 14px;
        line-height: 14px;
        font-weight: 300;
        margin-bottom: 12px;
        cursor: pointer;
        transition: .25s;
    }

    .game-item:hover {
        background: rgba(89, 89, 142, 0.5);
    }

    .game-item:not(:last-child) {
        margin-right: 12px;
    }

    .game-item input {
        margin: 0 8px 0 0;
        cursor: pointer;
    }

    .game-list {
        padding: 0;
        margin: 20px 0 50px;
    }

    .membership-icon {
        width: 30px;
        margin: -5px 10px -5px 0;
        vertical-align: top;
    }

    .btn-cancel {
        width: calc(50% - 10px);
        margin-left: 0 !important;
    }

    .btn-primary {
        width: calc(50% - 10px);
    }

    .membership-table-header {
        display: flex;
        width: 100%;
        margin-bottom: 15px;
    }

    .membership-table-header > div {
        width: 20%;
        padding: 15px 50px;
        background: #CAD5E0;
        color: #272C33;
        font-size: 18px;
        line-height: 20px;
        font-weight: 500;
    }

    .membership-table-header > div:first-child {
        border-radius: 8px 0 0 8px;
    }

    .membership-table-header > div:last-child {
        border-radius: 0 8px 8px 0;
    }

    .membership-table-row {
        border: 1px solid #CAD5E0;
        border-radius: 8px;
        display: flex;
        width: 100%;
        margin-bottom: 10px;
    }

    .membership-table-row > div {
        width: 20%;
        padding: 15px 50px;
        font-size: 20px;
        line-height: 20px;
        font-weight: 500;
        display: flex;
        align-items: center;
    }

    .membership-table-row .icon {
        width: 30px;
        border-radius: 50%;
        margin-right: 10px;
        border: 1px solid #cad5e0;
    }

    .membership-name {
        text-transform: capitalize;
    }

    .status-active {
        color: #27AE60;
    }

    .status-queue {
        color: #ff9800;
    }

    .my-memberships-table {
        margin: 0 auto 15px;
        max-width: 1174px;
    }

    .membership-table-header > div:nth-child(2),
    .membership-table-header > div:nth-child(4) {
        width: 30%;
    }

    .membership-table-row > div:nth-child(2),
    .membership-table-row > div:nth-child(4) {
        width: 30%;
    }

    .label {
        font-size: 15px;
        line-height: 20px;
        color: #61758A;
    }

    @media(max-width: 1600px) {
        .membership-card {
            margin: 0 10px;
        }

        .my-memberships-table {
            max-width: 1114px;
        }
    }

    @media(max-width: 1400px) {
        .card-body {
            padding: 20px;
        }

        .price {
            font-size: 25px;
        }

        .membership-list {
            margin: 50px 0 30px;
        }

        .card-header {
            font-size: 22px;
        }

        .my-memberships-table {
            max-width: 100%;
            margin: 0 10px;
        }

        .membership-table-row > div,
        .membership-table-header > div {
            padding: 15px 20px;
            font-size: 16px;
        }
    }

    @media(max-width: 1200px) {
        .membership-list {
            flex-wrap: wrap;
        }

        .membership-card {
            margin-bottom: 15px;
            width: 280px;
        }
    }

    @media(max-width: 992px) {
        .membership-card:hover {
            transform: none;
            border-color: #61758A;
            box-shadow: none;
            filter: none;
        }
    }

    @media(max-width: 768px) {
        .selected-membership {
            padding: 20px;
        }

        .game-list {
            display: flex;
            flex-wrap: wrap;
        }

        .game-item {
            margin-bottom: 10px;
        }

        .selected-membership .left-text {
            text-align: center;
            padding-left: 0;
        }

        .selected-membership .right-text {
            text-align: center;
            margin-top: 15px;
            padding-right: 0;
        }

        .membership-table-header {
            display: none;
        }

        .membership-table-row {
            flex-wrap: wrap;
            padding-bottom: 13px;
        }

        .membership-table-row > div:first-child .icon {
            width: 40px;
        }

        .membership-name {
            font-size: 30px;
            font-weight: 600;
        }

        .membership-table-row > div {
            width: 100%;
            position: relative;
            margin-bottom: 13px;
            padding: 20px;
        }

        .membership-table-row > div:first-child:after {
            content: "";
            height: 1px;
            position: absolute;
            background: rgba(89, 89, 142, 0.3);
            left: 20px;
            right: 20px;
            bottom: 0;
        }

        .membership-table-row > div:not(:first-child) {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 7px 20px;
            margin-bottom: 0;
            font-size: 15px;
        }

        .membership-table-row > div:nth-child(2) > span:last-child {
            display: flex;
            align-items: center;
        }

        .membership-table-row > div:nth-child(2) .icon {
            width: 24px;
        }
    }
</style>
